import { render, staticRenderFns } from "./VekaletUcretiHesaplayici.vue?vue&type=template&id=4cb53f96"
import script from "./VekaletUcretiHesaplayici.vue?vue&type=script&lang=ts"
export * from "./VekaletUcretiHesaplayici.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports